"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdDatepicker = _interopRequireDefault(require("cccisd-datepicker"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _schedulerStyle = _interopRequireDefault(require("./schedulerStyle.css"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _undo = _interopRequireDefault(require("cccisd-icons/undo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DATE_FORMAT_DATEPICKER = 'd MMM yyyy, h:mm a';
var DATE_FORMAT_MOMENT = 'D MMM YYYY, h:mm A';
var Scheduler = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Scheduler() {
    var _this;
    _classCallCheck(this, Scheduler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Scheduler, [].concat(args));
    _defineProperty(_this, "state", {
      isAddingSchedule: false,
      isListCollapsed: true,
      isSentCollapsed: true,
      completedScheduledMessageList: [],
      currentScheduledMessageList: [],
      tzAbbrev: _momentTimezone["default"].tz(_momentTimezone["default"].tz.guess()).format('z'),
      newDatetime: null,
      newInPast: false,
      newMessageKey: 1,
      editDatetime: null,
      editInPast: '',
      editMessageId: null
    });
    _defineProperty(_this, "sortScheduledMessageLists", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var templateMessageObject, children, completedScheduledMessageList, currentScheduledMessageList, _iterator, _step, child, clonedChild;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            templateMessageObject = _this.props.templateMessageObject;
            children = templateMessageObject ? templateMessageObject.children : [];
            if (!(!children || !children.length)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            completedScheduledMessageList = [];
            currentScheduledMessageList = [];
            _iterator = _createForOfIteratorHelper(children);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                child = _step.value;
                clonedChild = (0, _cloneDeep2["default"])(child);
                if (clonedChild.completedAt) {
                  completedScheduledMessageList.push(clonedChild);
                } else {
                  currentScheduledMessageList.push(clonedChild);
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _context.n = 2;
            return _this.setState({
              completedScheduledMessageList: (0, _sortBy2["default"])(completedScheduledMessageList, 'scheduleTime'),
              currentScheduledMessageList: (0, _sortBy2["default"])(currentScheduledMessageList, 'scheduleTime')
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "toggleCollapse", function () {
      _this.setState(function (prevState) {
        return {
          isListCollapsed: !prevState.isListCollapsed,
          isAddingSchedule: prevState.isListCollapsed
        };
      });
    });
    _defineProperty(_this, "toggleSent", function () {
      _this.setState(function (prevState) {
        return {
          isSentCollapsed: !prevState.isSentCollapsed
        };
      });
    });
    _defineProperty(_this, "onSelect", function (value) {
      _this.setState({
        newDatetime: value
      });
    });
    _defineProperty(_this, "onSelectEdit", function (value) {
      _this.setState({
        editDatetime: value
      });
    });
    _defineProperty(_this, "addSchedule", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var newScheduleItem;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (_this.state.newDatetime) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            if (!(new Date().getTime() > _this.state.newDatetime.getTime())) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return _this.setState({
              newInPast: true
            });
          case 2:
            _this.props.onScheduleError();
            return _context2.a(2);
          case 3:
            newScheduleItem = {
              messageId: "new".concat(_this.state.newMessageKey),
              scheduleTime: (0, _momentTimezone["default"])(_this.state.newDatetime).utc().format(),
              isNew: true
            };
            _context2.n = 4;
            return _this.setState(function (prevState) {
              return {
                currentScheduledMessageList: [].concat(_toConsumableArray(prevState.currentScheduledMessageList), [newScheduleItem]),
                newMessageKey: prevState.newMessageKey + 1,
                newInPast: false
              };
            });
          case 4:
            _this.props.onScheduleChange(_this.state.currentScheduledMessageList);
            _this.clearNewItem();
          case 5:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "additionalOutsideTest", function (e) {
      // if you click in the calendar, don't close the picker yet
      var node = e.target;
      var isClickedCalendar = false;
      while (node) {
        if (node.id === 'cccisd-datepicker') {
          isClickedCalendar = true;
          break;
        }
        node = node.parentNode;
      }
      return !isClickedCalendar;
    });
    _defineProperty(_this, "clearNewItem", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return _this.setState({
              isAddingSchedule: false,
              newInPast: false,
              newDatetime: null
            });
          case 1:
            if (!_this.state.editInPast) {
              _this.props.onScheduleErrorResolved();
            }
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })));
    _defineProperty(_this, "editSchedule", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(message) {
        var scheduleTime;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              scheduleTime = _typeof(message.scheduleTime) === 'object' ? message.scheduleTime : (0, _momentTimezone["default"])(_momentTimezone["default"].utc(message.scheduleTime).format()).toDate();
              if (!message.originalScheduleTime) {
                message.originalScheduleTime = message.scheduleTime;
              }
              delete message.toDelete;
              _context4.n = 1;
              return _this.setState({
                editDatetime: scheduleTime,
                editInPast: '',
                editMessageId: message.messageId
              });
            case 1:
              if (_this.state.newInPast) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return _this.props.onScheduleErrorResolved();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "completeEdit", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(message) {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(new Date().getTime() > _this.state.editDatetime.getTime())) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this.setState({
                editInPast: message.messageId
              });
            case 1:
              _this.props.onScheduleError();
              return _context5.a(2);
            case 2:
              message.scheduleTime = (0, _momentTimezone["default"])(_this.state.editDatetime).utc().format();
              _context5.n = 3;
              return _this.props.onScheduleChange(_this.state.currentScheduledMessageList);
            case 3:
              _context5.n = 4;
              return _this.setState({
                editDatetime: null,
                editInPast: '',
                editMessageId: null
              });
            case 4:
              if (_this.state.newInPast) {
                _context5.n = 5;
                break;
              }
              _context5.n = 5;
              return _this.props.onScheduleErrorResolved();
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "revertEditedToOriginal", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(message) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              message.scheduleTime = message.originalScheduleTime;
              _context6.n = 1;
              return _this.setState({
                editDatetime: null,
                editInPast: '',
                editMessageId: null
              });
            case 1:
              if (_this.state.newInPast) {
                _context6.n = 2;
                break;
              }
              _context6.n = 2;
              return _this.props.onScheduleErrorResolved();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "removeSchedule", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(message) {
        var newList, newPartialState, foundMessage, _iterator2, _step2, item, _t;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              newList = [];
              newPartialState = {};
              foundMessage = false;
              _iterator2 = _createForOfIteratorHelper(_this.state.currentScheduledMessageList);
              _context7.p = 1;
              _iterator2.s();
            case 2:
              if ((_step2 = _iterator2.n()).done) {
                _context7.n = 6;
                break;
              }
              item = _step2.value;
              if (!(item.messageId === message.messageId)) {
                _context7.n = 4;
                break;
              }
              foundMessage = true;
              if (message.messageId === _this.state.editInPast) {
                newPartialState.editInPast = '';
              }
              if (message.isNew) {
                _context7.n = 3;
                break;
              }
              item.toDelete = true;
              _context7.n = 4;
              break;
            case 3:
              return _context7.a(3, 5);
            case 4:
              newList.push(item);
            case 5:
              _context7.n = 2;
              break;
            case 6:
              _context7.n = 8;
              break;
            case 7:
              _context7.p = 7;
              _t = _context7.v;
              _iterator2.e(_t);
            case 8:
              _context7.p = 8;
              _iterator2.f();
              return _context7.f(8);
            case 9:
              if (!foundMessage) {
                newPartialState.newInPast = false;
              }
              newPartialState.currentScheduledMessageList = newList;
              _context7.n = 10;
              return _this.setState(_objectSpread({}, newPartialState));
            case 10:
              _context7.n = 11;
              return _this.props.onScheduleChange(newList);
            case 11:
              if (!(!_this.state.newInPast && !_this.state.editInPast)) {
                _context7.n = 12;
                break;
              }
              _context7.n = 12;
              return _this.props.onScheduleErrorResolved();
            case 12:
              return _context7.a(2);
          }
        }, _callee7, null, [[1, 7, 8, 9]]);
      }));
      return function (_x4) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "restoreSchedule", function (messageId) {
      var newList = [];
      var _iterator3 = _createForOfIteratorHelper(_this.state.currentScheduledMessageList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          if (item.messageId === messageId) {
            delete item.toDelete;
          }
          newList.push(item);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      _this.setState({
        currentScheduledMessageList: newList
      });
      _this.props.onScheduleChange(newList);
    });
    _defineProperty(_this, "_renderScheduleList", function () {
      var _this$state = _this.state,
        currentScheduledMessageList = _this$state.currentScheduledMessageList,
        isAddingSchedule = _this$state.isAddingSchedule,
        editInPast = _this$state.editInPast,
        newDatetime = _this$state.newDatetime,
        newInPast = _this$state.newInPast,
        tzAbbrev = _this$state.tzAbbrev;
      var allList = _toConsumableArray(currentScheduledMessageList);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
        className: _schedulerStyle["default"].Panel_listArea
      }, allList.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map2["default"])(allList, function (message) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: message.messageId,
          className: (0, _classnames["default"])(message.toDelete ? _schedulerStyle["default"].toDelete : '', _schedulerStyle["default"].Panel_listItem)
        }, _this._renderScheduledCell(message));
      })), isAddingSchedule && /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])('mb-3', _schedulerStyle["default"].Panel_listItem)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-danger', _schedulerStyle["default"].forceTextWhite, _schedulerStyle["default"].Panel_listItem___column1),
        onClick: function onClick() {
          _this.clearNewItem();
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column2
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
        additionalOutsideTest: _this.additionalOutsideTest,
        className: (0, _classnames["default"])(_schedulerStyle["default"].datePicker, newInPast ? _schedulerStyle["default"].datePicker___Error : null),
        clickedOutside: function clickedOutside() {
          _this.addSchedule();
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
        selected: newDatetime !== null ? newDatetime : null,
        onChange: _this.onSelect,
        dateFormat: DATE_FORMAT_DATEPICKER,
        placeholderText: "Enter date and time",
        showTimeSelect: true
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-text"
      }, tzAbbrev)))), /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])('mb-3', _schedulerStyle["default"].Panel_listItem)
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _schedulerStyle["default"].forceTextWhite, _schedulerStyle["default"].fullWidth),
        onClick: function onClick() {
          if (!_this.state.isAddingSchedule) {
            _this.setState({
              isAddingSchedule: true
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), "\xA0\xA0Add Schedule"))), newInPast || editInPast ? /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('alert alert-danger text-danger', _schedulerStyle["default"].Panel_error)
      }, "Scheduled dates must be in the future") : null);
    });
    _defineProperty(_this, "_renderSentList", function () {
      var allList = _toConsumableArray(_this.state.completedScheduledMessageList);
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: _schedulerStyle["default"].Panel_listArea
      }, allList.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _map2["default"])(allList, function (message) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: message.messageId,
          className: _schedulerStyle["default"].Panel_listItem
        }, _this._renderSentCell(message.completedAt));
      })));
    });
    _defineProperty(_this, "_renderScheduledCell", function (message) {
      var _this$state2 = _this.state,
        editDatetime = _this$state2.editDatetime,
        editInPast = _this$state2.editInPast,
        editMessageId = _this$state2.editMessageId,
        tzAbbrev = _this$state2.tzAbbrev;
      var messageId = message.messageId,
        scheduleTime = message.scheduleTime,
        isNew = message.isNew,
        toDelete = message.toDelete;
      var isExisting = !isNew;
      if (message.messageId === editMessageId) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _schedulerStyle["default"].Panel_listItem___column1
        }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Cancel Edit Schedule"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn btn-secondary', _schedulerStyle["default"].forceTextGray),
          onClick: function onClick() {
            _this.revertEditedToOriginal(message);
          }
        }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _schedulerStyle["default"].Panel_listItem___column2
        }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
          additionalOutsideTest: _this.additionalOutsideTest,
          className: (0, _classnames["default"])(_schedulerStyle["default"].datePicker, editInPast ? _schedulerStyle["default"].datePicker___Error : null),
          clickedOutside: function clickedOutside() {
            _this.completeEdit(message);
          }
        }, /*#__PURE__*/_react["default"].createElement(_cccisdDatepicker["default"], {
          selected: editDatetime,
          onChange: _this.onSelectEdit,
          dateFormat: DATE_FORMAT_DATEPICKER,
          placeholderText: "Enter date and time",
          showTimeSelect: true
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "input-group-text"
        }, tzAbbrev))));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, toDelete ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Undo Delete",
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _schedulerStyle["default"].forceTextWhite),
        onClick: function onClick() {
          _this.restoreSchedule(messageId);
        }
      }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null))) : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Delete",
        type: "error",
        className: _schedulerStyle["default"].Panel_listItem___column1
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-danger', _schedulerStyle["default"].forceTextWhite),
        onClick: function onClick() {
          if (isExisting) {
            (0, _cccisdConfirm["default"])({
              message: 'Mark deleted',
              description: 'Mark scheduled message for deletion? Deletion will be performed when form is submitted.',
              confirmLabel: 'Yes',
              abortLabel: 'Cancel'
            }).then(function () {
              _this.removeSchedule(message);
            });
          } else {
            _this.removeSchedule(message);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column2
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])(_schedulerStyle["default"].textColor, _schedulerStyle["default"].noUnderline),
        onClick: function onClick() {
          _this.editSchedule(message);
        }
      }, (0, _momentTimezone["default"])(_momentTimezone["default"].utc(scheduleTime).format()).format(DATE_FORMAT_MOMENT), " (", tzAbbrev, ")")));
    });
    _defineProperty(_this, "_renderSentCell", function (datetime) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_listItem___column1
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_schedulerStyle["default"].textColor, _schedulerStyle["default"].Panel_listItem___column2)
      }, (0, _momentTimezone["default"])(_momentTimezone["default"].utc(datetime).format()).format(DATE_FORMAT_MOMENT), " (", _this.state.tzAbbrev, ")"));
    });
    return _this;
  }
  _inherits(Scheduler, _React$Component);
  return _createClass(Scheduler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.sortScheduledMessageLists();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _iterator4 = _createForOfIteratorHelper(this.state.currentScheduledMessageList),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          if (child.toDelete) {
            delete child.toDelete;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var sentStyle = this.state.isSentCollapsed ? _schedulerStyle["default"].Panel_collapseArrow___collapsed : _schedulerStyle["default"].Panel_collapseArrow___expanded;
      var collapseStyle = this.state.isListCollapsed ? _schedulerStyle["default"].Panel_collapseArrow___collapsed : _schedulerStyle["default"].Panel_collapseArrow___expanded;
      var sentNum = this.state.completedScheduledMessageList.length;
      var scheduledNum = this.state.currentScheduledMessageList.filter(function (item) {
        return !item.toDelete;
      }).length;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !sentNum ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card', _schedulerStyle["default"].Panel, _schedulerStyle["default"].Panel___sent)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card-header text-bg-primary', _schedulerStyle["default"].Panel_header, _schedulerStyle["default"].Panel_header___gray)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_collapseArrow,
        onClick: this.toggleSent.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: sentStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleSent.bind(null),
        className: (0, _classnames["default"])('fs-6', 'card-title', _schedulerStyle["default"].Panel_headerText)
      }, "Sent List ", "(".concat(sentNum, ")"))), !this.state.isSentCollapsed && this._renderSentList()), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card', _schedulerStyle["default"].Panel)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card-header text-bg-primary', _schedulerStyle["default"].Panel_header)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _schedulerStyle["default"].Panel_collapseArrow,
        onClick: this.toggleCollapse.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: collapseStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleCollapse.bind(null),
        className: (0, _classnames["default"])('fs-6', 'card-title', _schedulerStyle["default"].Panel_headerText)
      }, "Scheduling List ", "(".concat(scheduledNum, ")"))), !this.state.isListCollapsed && this._renderScheduleList()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Scheduler, "propTypes", {
  deploymentId: _propTypes["default"].number.isRequired,
  templateMessageObject: _propTypes["default"].object,
  onScheduleChange: _propTypes["default"].func,
  onScheduleError: _propTypes["default"].func,
  onScheduleErrorResolved: _propTypes["default"].func
});
_defineProperty(Scheduler, "defaultProps", {
  templateMessageObject: null,
  onScheduleChange: function onScheduleChange() {}
});